/*-----------------------------------------------------------------
- Cart trans
-----------------------------------------------------------------*/
export default {
    
    coupons: 'کوپن تخفیف',
    
};
